"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Presell = function Presell(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "PresellTitle PresellDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "PresellTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "PresellDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M18.474 19.452a.98.98 0 1 0-.007 1.96.98.98 0 0 0 .007-1.96zm-2.543-4.722a2.973 2.973 0 1 0 0-5.945 2.973 2.973 0 0 0 0 5.946zm0-5.081a2.113 2.113 0 1 1 0 4.225 2.113 2.113 0 0 1 0-4.225z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M19.083 16.527h-6.304a3.097 3.097 0 0 0-3.096 3.097v6.71h12.49V19.62a3.097 3.097 0 0 0-3.09-3.093zm2.233 8.946h-10.77v-5.85c0-1.233 1-2.234 2.233-2.236h6.304a2.237 2.237 0 0 1 2.25 2.233l-.017 5.853zm4.022-14.193a2.973 2.973 0 1 0 0-5.946 2.973 2.973 0 0 0 0 5.946zm0-5.083a2.113 2.113 0 1 1 0 4.226 2.113 2.113 0 0 1 0-4.226z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M28.831 13.048h-6.3a3.097 3.097 0 0 0-2.918 2.04l.809.293a2.24 2.24 0 0 1 2.102-1.473h6.307c1.234 0 2.235 1 2.237 2.234v5.849h-7.601v.86h8.46v-6.71a3.097 3.097 0 0 0-3.096-3.093zM5.726 11.28a2.973 2.973 0 1 1 0-5.946 2.973 2.973 0 0 1 0 5.946zm0-5.083a2.113 2.113 0 1 0 0 4.226 2.113 2.113 0 0 0 0-4.226zm-2.629 6.851h6.3a3.097 3.097 0 0 1 2.918 2.04l-.809.293a2.24 2.24 0 0 0-2.102-1.473H3.097c-1.234 0-2.235 1-2.237 2.234v5.849h7.601v.86H0v-6.71a3.097 3.097 0 0 1 3.097-3.093z"
  }));
};

Presell.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Presell.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Presell;
exports["default"] = _default;